define('views/parts/tutorial-box',[
    // Libs
    'underscore', 'backbone', 'mustache', 'bootbox',
    // services
    'services/viewport',
    'services/api',
    'services/events/user-events',
    'services/i18n',
    // views
    'views/parts/modal/create-test-client-modal',
    // templates
    'text!templates/parts/tutorial-box.html'
], function(
    // Libs
    _, Backbone, Mustache, Bootbox,
    // services
    Viewport,
    API,
    UserEvents,
    I18n,
    // views
    VCreateTestClientModal,
    // templates
    TTutorialBox
) {

    var VTutorialBox = Backbone.Epoxy.View.extend({
        template: TTutorialBox,

        events: {
            'click': 'onClick',
            "click .checkbox": 'onToggleDone'
        },

        initialize: function(opt) {
            this.model = opt.model;
            this.profile = opt.profile;

            this.listenTo(UserEvents, 'testUserAdded', this.render);
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(_.extend({
                isCompleted: this.isCompleted.bind(this)
            }, this.model.toJSON())));

            this.$el.empty().append(html);
            this.$el.find('.checkbox').tooltip();

            return this;
        },

        getIntercomTourId: function() {
            var key = "desktop_";

            if (Viewport.isMobile()) {
                key = "mobile_";
            }

            if (this.profile.get('language').includes('fr')) {
                key += "fr";
            } else {
                key += "en";
            }

            return this.model.get('intercomIds')[key];
        },

        isCompleted: function() {
            return this.profile.get('completedTutorials').includes(this.model.get('_id'));
        },

        isTestClientRequired: function() {
            return this.model.get('requiresTestClient') && this.profile.get('isHiddenFromClientsList');
        },

        startTutorial: function() {
            window.Intercom('startTour', this.getIntercomTourId());
        },

        markAsCompleted: function() {
            if (! this.isCompleted()) {
                this.profile.markTutorialAsCompleted(this.model.id);
                UserEvents.refreshCompletedTutorialsCount();
                this.render();
            }
        },

        displayBootbox: function() {
            Bootbox.alert({
                message: I18n.t('Looks like you already created your first client. No need to go through this tutorial.')
            });
        },

        userHasVisibleClients: function(user) {
            return (user.isHiddenFromClientsList && user._totalClientsCount > 1) || (!user.isHiddenFromClientsList && user._totalClientsCount >= 1);
        },

        checkIfUserCanCompleteTutorial: function(user) {
            if (this.userHasVisibleClients(user)) {
                this.displayBootbox();
                this.markAsCompleted();
            } else {
                this.markAsCompleted();
                if (this.model.id === '5fd8f2fda1bc777b08259b62') {
                    Backbone.history.navigate('#/supervisor');
                }
                window.setTimeout(this.startTutorial.bind(this), 500);
            }
        },

        onClick: function(e) {
            if (this.model.get('requiresNoClient')) {
                Backbone.ajax({
                    url: API.url('users/me'),
                    method: 'GET',
                    success: this.checkIfUserCanCompleteTutorial.bind(this)
                });
                return;
            }

            if (this.isTestClientRequired() && !this.isCompleted()) {
                (new VCreateTestClientModal(this.profile)).render();
                return false;
            }

            this.markAsCompleted();
            if (this.model.id === '5fd8f2fda1bc777b08259b62') {
                Backbone.history.navigate('#/supervisor');
            }
            window.setTimeout(this.startTutorial.bind(this), 500);
        },

        onToggleDone: function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (this.model.get('requiresNoClient') && !this.isCompleted()) {
                Backbone.ajax({
                    url: API.url('users/me'),
                    method: 'GET',
                    success: this.checkIfUserCanCompleteTutorial.bind(this)
                });
                return;
            }

            if (this.isTestClientRequired() && !this.isCompleted()) {
                (new VCreateTestClientModal(this.profile)).render();
                return false;
            }

            var completedTutorials = this.profile.get('completedTutorials');

            if (completedTutorials.includes(this.model.id)) {
                completedTutorials.splice(completedTutorials.indexOf(this.model.id), 1);
            } else {
                completedTutorials.push(this.model.id);
            }

            this.profile.save({ completedTutorials: completedTutorials }, {
                patch: true,
                success: this.render.bind(this)
            });
            UserEvents.refreshCompletedTutorialsCount();
        }
    });

    return VTutorialBox;
});

